export class SkechersCoLinereqModel {
    poNumber: string;
    poStyle: string;
    deliveryDate:any;
    exFactoryDate:any;
    destinations: SkechersDestinationModel[]


    constructor(poNumber: string, poStyle: string,deliveryDate:any,exFactoryDate:any,destinations: SkechersDestinationModel[]) {
        this.poNumber = poNumber
        this.poStyle = poStyle
        this.deliveryDate = deliveryDate
        this.exFactoryDate = exFactoryDate
        this.destinations = destinations
        
    }
}

export class SkechersDestinationModel {
    name: string;
    colors: SkechersColorModel[]

    constructor(name: string, colors: SkechersColorModel[]) {
        this.name = name
        this.colors = colors
    }
}

export class SkechersColorModel {
    name: string;
    sizes: SkechersSizeModel[]
    constructor(name: string, sizes: SkechersSizeModel[]) {
        this.name = name
        this.sizes = sizes
    }
}

export class SkechersSizeModel {
    name: string;
    qty: string;

    constructor(name: string, qty: string,) {
        this.name = name
        this.qty = qty
    }
}